import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=0d2496de&"
import script from "./TableBody.vue?vue&type=script&lang=js&"
export * from "./TableBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports